import type { DatabaseBlockModel } from '@blocksuite/affine-model';
import { ExternalGroupByConfigProvider } from '@blocksuite/data-view';
import { CalendarExternalSourceProvider } from '@blocksuite/data-view/view-presets';
import type { EditorHost } from '@blocksuite/std';

import { EditorHostKey } from '../context/host-context.js';
import { DatabaseBlockDataSource } from '../data-source.js';

/**
 * Build a `DatabaseBlockDataSource` for a database model with the standard
 * editor services wired in.
 *
 * Shared by `affine-database` (the database block itself) and
 * `affine-database-view-ref` (a single view of a database rendered on
 * another page), so both behave identically.
 */
export const createDatabaseDataSource = (
  model: DatabaseBlockModel,
  host: EditorHost
): DatabaseBlockDataSource => {
  return new DatabaseBlockDataSource(model, dataSource => {
    dataSource.serviceSet(EditorHostKey, host);
    host.std.provider.getAll(ExternalGroupByConfigProvider).forEach(config => {
      dataSource.serviceSet(ExternalGroupByConfigProvider(config.name), config);
    });
    host.std.provider.getAll(CalendarExternalSourceProvider).forEach(source => {
      dataSource.serviceSet(CalendarExternalSourceProvider(source.id), source);
    });
  });
};
